import { isEmpty, isNil } from 'lodash';

export default {

  computed: {
    ws: function () {
      return this.$store.getters['hotel/webSocket'];
    },
  },

  methods: {
    wsOnMessage(event) {
      // console.group('WebSocket RECEIVED');
      // console.log(event);
      // console.log(event.data);
      // console.groupEnd();
      const data = JSON.parse(event.data);

      if (isNil(data) || isNil(data.data)) {
        return;
      }

      this.wsHandleMessage(data.data.action, data, event);
    },
    wsHandleMessage(action, data, event) {

    },
    wsSend(msg) {
      // console.group('WebSocket SEND');
      // console.log(msg);
      // console.groupEnd();
      if (this.ws && this.ws.readyState === 1) {
        if (typeof msg === 'string') this.ws.send(msg);
        else this.ws.send(JSON.stringify(msg));
      }
    },
  },

  created() {
    this.$serviceBus.$on('ui.ws.onmessage', this.wsOnMessage);
  },

  beforeDestroy() {
    this.$serviceBus.$off('ui.ws.onmessage', this.wsOnMessage);
  },
};



// WEBPACK FOOTER //
// ./src/mixins/WebSocketMixin.js